"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWEEPSTAKES_V2_PAYOUT_AMOUNTS = exports.SweepstakesV2AttemptedEntryErrorType = exports.SweepstakesType = exports.SweepstakesV2Type = exports.SweepstakesOriginalType = exports.SweepstakesStatus = void 0;
var SweepstakesStatus;
(function (SweepstakesStatus) {
    SweepstakesStatus["OPEN"] = "OPEN";
    SweepstakesStatus["CLOSED"] = "CLOSED";
})(SweepstakesStatus || (exports.SweepstakesStatus = SweepstakesStatus = {}));
exports.SweepstakesOriginalType = {
    CASH: 'CASH', // means we are giving cash prizes
    MORTGAGE: 'MORTGAGE', // means we are give one month of mortgage payment
    PLAID_TRANSACTION: 'PLAID_TRANSACTION', // means we are paying for people's plaid transactions up to some cap
};
exports.SweepstakesV2Type = {
    MORTGAGE_PAYMENT: 'MORTGAGE_PAYMENT',
    HOME_PAYMENT: 'HOME_PAYMENT',
    CREDIT_CARD_PAYMENT: 'CREDIT_CARD_PAYMENT',
    EMPLOYEE: 'EMPLOYEE',
};
exports.SweepstakesType = {
    ...exports.SweepstakesOriginalType,
    ...exports.SweepstakesV2Type,
};
var SweepstakesV2AttemptedEntryErrorType;
(function (SweepstakesV2AttemptedEntryErrorType) {
    SweepstakesV2AttemptedEntryErrorType["NO_VALID_SWEEPSTAKES"] = "NO_VALID_SWEEPSTAKES";
    SweepstakesV2AttemptedEntryErrorType["NO_PLAID_CONNECTED"] = "NO_PLAID_CONNECTED";
    SweepstakesV2AttemptedEntryErrorType["NO_HOME_OWNERSHIP"] = "NO_HOME_OWNERSHIP";
    SweepstakesV2AttemptedEntryErrorType["INELIGIBLE_STATE"] = "INELIGIBLE_STATE";
    SweepstakesV2AttemptedEntryErrorType["ONE_ENTRY_PER_ADDRESS_PER_SWEEPSTAKES"] = "ONE_ENTRY_PER_ADDRESS_PER_SWEEPSTAKES";
    SweepstakesV2AttemptedEntryErrorType["NON_EMPLOYEE"] = "NON_EMPLOYEE";
    SweepstakesV2AttemptedEntryErrorType["BELOW_CREDIT_SCORE_THRESHOLD"] = "BELOW_CREDIT_SCORE_THRESHOLD";
    SweepstakesV2AttemptedEntryErrorType["UNKNOWN"] = "UNKNOWN";
})(SweepstakesV2AttemptedEntryErrorType || (exports.SweepstakesV2AttemptedEntryErrorType = SweepstakesV2AttemptedEntryErrorType = {}));
exports.SWEEPSTAKES_V2_PAYOUT_AMOUNTS = {
    [exports.SweepstakesV2Type.MORTGAGE_PAYMENT]: [2500],
    [exports.SweepstakesV2Type.CREDIT_CARD_PAYMENT]: [1000],
    [exports.SweepstakesV2Type.HOME_PAYMENT]: [1000],
    [exports.SweepstakesV2Type.EMPLOYEE]: [2, 1, 1],
};
